import { render, staticRenderFns } from "./SocialFeed.vue?vue&type=template&id=472e4863&"
import script from "./SocialFeed.vue?vue&type=script&lang=js&"
export * from "./SocialFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports